import { Box } from "@mui/system";
import React from "react";

const Map = () => (
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.2311711962066!2d106.80086541472234!3d10.87001416043178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x317527587e9ad5bf%3A0xafa66f9c8be3c91!2sUniversity%20of%20Information%20Technology%20VNU-HCM!5e0!3m2!1sen!2s!4v1639791872891!5m2!1sen!2s"
    width="100%"
    style={{ borderRadius: "4px" }}
    allowFullScreen=""
    loading="lazy"
  ></iframe>
);

export default Map;
